import { RegistrationStatsDto } from '../dtos/registration-stats.dto';
import { RegistrationStats } from '../models/registration-stats';

/**
 * Map to registration stat model.
 * @param {RegistrationStatsDto} dto Dto.
 * @returns {RegistrationStats}
 */
function fromDto(dto) {
  return {
    classRegistrationCount: dto.class?.total,
    classRegistrationAssignedCount: dto.class?.assigned,
    classRegistrationUnassignedCount: dto.class?.unassigned,
    proctorURegistrationCount: dto.proctoru?.total,
    proctorURegistrationAssignedCount: dto.proctoru?.assigned,
    proctorURegistrationUnassignedCount: dto.proctoru?.unassigned,
    eLearningLicenseCount: dto.elearning?.total,
    eLearningLicenseAssignedCount: dto.elearning?.assigned,
    eLearningLicenseUnassignedCount: dto.elearning?.unassigned,
  };
}

export const registrationStatsMapper = {
  fromDto,
};
